// extracted by mini-css-extract-plugin
export default {"container":"xC-z","dimension":"yC-z","dimensionLabels":"zC-z"};